import { render, staticRenderFns } from "./BlueskySection.vue?vue&type=template&id=090d9018"
import script from "./BlueskySection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlueskySection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports